<template>
  <v-menu bottom left min-width="200" offset-y origin="top right" transition="scale-transition">
    <template v-slot:activator="{ attrs, on }">

      <v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">
        <v-tooltip bottom color="warning">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" v-if="isReverse" color="white">mdi-account</v-icon>
            <v-icon v-bind="attrs" v-on="on" v-if="isReverse === false">mdi-account</v-icon>
          </template>
          <span>Profile Details</span>
        </v-tooltip>
      </v-btn>
    </template>
    <v-list :tile="false" flat nav>
      <v-list-item>
        <v-list-item-title>{{ userName }}</v-list-item-title>
      </v-list-item>
    </v-list>
    <v-list :tile="false" flat nav>
      <template v-for="(p, i) in profile">
        <v-divider v-if="p.divider" :key="`divider-${i}`" class="mb-2 mt-2" />
        <v-list-item v-else :key="`item-${i}`" @click="menuClick(`item-${i}`)">
          <v-list-item-title>{{ p.title }}</v-list-item-title>
          <v-icon>{{ p.icon }}</v-icon>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { get } from "vuex-pathify";
export default {
  name: "DefaultAccount",

  data: () => ({
    profile: [
      { title: "Profile", icon: "mdi-account-circle-outline" },
      { title: "Change Password", icon: "mdi-key-change" },
      { divider: true },
      { title: "Log out", icon: "mdi-logout" },
    ],
  }),

  computed: {
    ...get("user", ["isLogin", "userName", "id"]),
    ...get("app", ["drawer", "mini", "isReverse"]),
  },
  methods: {
    menuClick(menuKey) {
      if (menuKey === "item-0") {
        if (this.id.charAt(0) === "U")
          this.$router.replace({ name: "Professor Profile" });
        else this.$router.replace({ name: "Student Profile" });
      }
      if (menuKey === "item-1") {
        this.$router.replace({ name: "Change Password" });
      } else if (menuKey === "item-3") {
        this.$store.dispatch("user/logout").then(() => {
          window.location = "/login";
        });
      }
    },
  },
};
</script>
